import { TagsList } from "@components/Listings/ListingsFilter/components/ListingsFilterCheckboxList"
import { useFilterStore } from "@components/Listings/ListingsFilter/store"
import { useMemo } from "react"
import { useFilterData } from "@components/Listings/ListingsFilter/FilterDataContextProvider"
import { ownImplicitActiveStatuses, ownNotActiveStatuses } from "@utils/const"

export function TagsStatus() {
    const selectedItems = useFilterStore((s) => s.listing_status_in)
    const onTagListChange = useFilterStore((s) => s.onTagListChange)
    const filterData = useFilterData()
    const items = useMemo(() => {
        const s = (filterData?.listingFilter?.listing_status?.split(";") || []).map((i) => ({ key: i }))
        return s.filter((i) => !ownNotActiveStatuses.includes(i.key) && !ownImplicitActiveStatuses.includes(i.key))
    }, [filterData])

    return <TagsList selectedItems={selectedItems} items={items} onItemChange={onTagListChange("listing_status")} title="Status" />
}
